import BoatPage, { getServerSideProps as getBoatDetailSSP } from '../[lang]/boats/[id]';

export default BoatPage;
export const getServerSideProps = getBoatDetailSSP;
